/* istanbul ignore file */
import welcomePage from './welcomePage/welcomePage.config';
import authorizeRequestPage from './authorizeRequestPage/authorizeRequestPage.config';
import successPage from './successPage/successPage.config';
import reviewAccountPage from './reviewAccountPage/reviewAccountPage.config';

// In near future, shared pages will also be published to Artifactory
import processSpinPage from './sharedPages/spinPage/processSpinPage.config';
import signInSpinPage from './sharedPages/spinPage/signInSpinPage.config';
import errorPage from './sharedPages/errorPage/errorPage.config';
import createCasePage from './sharedPages/createCasePage/createCasePage.config';
import createCaseSuccessPage from './sharedPages/createCaseSuccessPage/createCaseSuccessPage.config';
import agentAvailable from './sharedPages/agentAvailablePage/agentAvailable.config';

// CM pages
import cmValidation from './cmValidationPage/cmValidation.config';
import newCMInformation from './newCMPage/newCMInformation.config';

export default {
  welcomePage,
  reviewAccountPage,
  authorizeRequestPage,
  errorPage,
  successPage,
  createCaseSuccessPage,
  processSpinPage,
  signInSpinPage,
  createCasePage,
  cmValidation,
  newCMInformation,
  agentAvailable
};
